import { useContext, useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import { ILogData } from "../interfaces/log-data-interface";
import { ReactComponent as PrevArrow } from "../images/prev-arrow-icon.svg";
import { ReactComponent as NextArrow } from "../images/next-arrow-icon.svg";
import { IAdmin } from "../interfaces/admin-interface";
import DropdownList from "./Dropdown/DropdownList";
import { DropdownContext } from "../contexts/DropdownContext";

interface IPagination {
  data: ILogData[] | IAdmin[];
  setCurrentData: Function;
}
const Pagination = ({ data, setCurrentData }: IPagination) => {
  const { dropdownRef, setDropdownRef } = useContext(DropdownContext);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [dropdownIsOpen, setDropdownIsOpen] = useState(false);
  const [selectedPage, setSelectedPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  useEffect(() => {
    if (!dropdownIsOpen) {
      setDropdownRef(null);
    } else {
      setDropdownRef("dropdown");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropdownIsOpen]);
  useEffect(() => {
    if (!dropdownRef) {
      setDropdownIsOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropdownRef]);
  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentData(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemOffset, itemsPerPage, data]);
  const handlePageClick = (event: any) => {
    setSelectedPage(event.selected);
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  return (
    <SContainer>
      <SItemPerPageSelectorContainer>
        Item per page:
        <SSelector onClick={() => setDropdownIsOpen(true)}>
          {itemsPerPage}
        </SSelector>
        <DropdownList
          dropdownIsOpen={dropdownIsOpen}
          choices={[
            { label: 10, icon: undefined },
            { label: 20, icon: undefined },
            { label: 50, icon: undefined },
            { label: 100, icon: undefined },
          ]}
          dropdownSelected={itemsPerPage}
          onclick={(e: number) => {
            setItemsPerPage(e);
            setDropdownIsOpen(false);
          }}
          setDropdownIsOpen={setDropdownIsOpen}
          css={{
            margin: "-185px 0px 0px 100px",
            width: "fit-content",
          }}
        />
      </SItemPerPageSelectorContainer>
      {pageCount > 1 && (
        <SReactPaginate
          breakLabel="..."
          nextLabel={
            <SButton className={selectedPage + 1 === pageCount ? "grey" : ""}>
              Next <NextArrow />
            </SButton>
          }
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel={
            <SButton className={selectedPage === 0 ? "grey" : ""}>
              <PrevArrow /> Previous
            </SButton>
          }
        />
      )}
    </SContainer>
  );
};
export default Pagination;
const SButton = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: var(--radius-xs);
  transition:
    background-color var(--transition),
    color var(--transition);
  &:hover {
    background-color: var(--color-primary-soft);
  }
  &.grey {
    cursor: not-allowed;
    color: var(--color-text-subtle);
    & > svg > path {
      fill: var(--color-text-subtle);
    }
    &:hover {
      background-color: transparent;
    }
  }
`;
const SSelector = styled.div`
  cursor: pointer;
  margin-left: 10px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xs);
  padding: 2px 12px;
  background: var(--color-surface);
  transition:
    border-color var(--transition),
    box-shadow var(--transition);
  &:hover {
    border-color: var(--color-primary);
  }
`;
const SItemPerPageSelectorContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  color: var(--color-text-muted);
  font-size: 13px;
`;
const SContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
  width: 100%;
`;
const SReactPaginate = styled(ReactPaginate)`
  display: flex;
  list-style-type: none;
  padding: 0;
  margin: 0;
  gap: 4px;
  color: var(--color-text-muted);
  font-size: 13px;
  & > li {
    cursor: pointer;
    min-width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    border-radius: var(--radius-xs);
    transition:
      background-color var(--transition),
      color var(--transition);
    &:hover {
      background-color: var(--color-primary-soft);
    }
    &.selected {
      background: var(--color-primary);
      color: #fff;
      font-weight: 600;
    }
    &.selected:hover {
      background: var(--color-primary-hover);
    }
    & > a {
      outline: none;
    }
  }
`;
